import React, {Fragment} from 'react';
import BgRoutes from '../../assets/img/homepage/bg-service-routes.svg';
import OurServicesFastestRoute from '../../assets/img/homepage/OurServicesFastestRoute.webp';
import BgSearch from '../../assets/img/homepage/bg-service-search.svg';
import OurServicesSearch from '../../assets/img/homepage/OurServicesSearch.webp';
import BgOnPt from '../../assets/img/homepage/bg-service-onpt.svg';
import OurServicesTrack from '../../assets/img/homepage/OurServicesTrack.webp';
import {Typography} from '@material-tailwind/react';

const OurServices = () => {
  return (
    <Fragment>
      <div className="w-full min-h-[500px] flex justify-center px-4 lg:px-0">
        <div className="w-full max-w-[1240px] gap-8 grid grid-cols-1 lg:grid-cols-3 lg:gap-10">
          {/*Search*/}
          <div className="flex flex-col items-center justify-start gap-3 overflow-hidden lg:my-0">
            <div style={{backgroundImage: `url(${BgSearch})`}}
                 className="border border-solid border-[#EAEAEE] rounded-[24px] box-border w-full flex justify-center bg-white items-end h-[260px] lg:h-[300px]">
              <img
                src={OurServicesSearch}
                alt="service term search img content"
                className={'h-[245px] lg:h-[280px]'}
                loading={'lazy'}
              />
            </div>

            <div className='w-full flex flex-col items-center justify-center gap-2'>
              <Typography
                variant='h5'
                className='text-[#282B59] text-[24px] font-extrabold leading-hundred tracking-[0px] font-nunito text-center'
              >
                Search
              </Typography>

              <Typography
                variant='paragraph'
                className='text-[#53557A] text-lg font-nunito font-normal leading-hundred tracking-[0px] text-center'
              >
                Enter your destination
              </Typography>
            </div>
          </div>

          {/*Fastest & Cheapest Route*/}
          <div className="flex flex-col items-center justify-start gap-3 overflow-hidden lg:my-0">
            <div style={{backgroundImage: `url(${BgRoutes})`}}
                 className="border border-solid border-[#EAEAEE] rounded-[24px] box-border w-full flex justify-center bg-white items-end h-[260px] lg:h-[300px]">
              <img
                src={OurServicesFastestRoute}
                alt="service term search img content"
                className={'h-[245px] lg:h-[280px]'}
                loading={'lazy'}
              />
            </div>

            <div className='w-full flex flex-col items-center justify-center gap-2'>
              <Typography
                variant='h5'
                className='text-[#282B59] text-[24px] font-extrabold leading-hundred tracking-[0px] font-nunito text-center'
              >
                Fastest & Cheapest Route
              </Typography>

              <Typography
                variant='paragraph'
                className='text-[#53557A] text-lg font-nunito font-normal leading-hundred tracking-[0px] text-center'
              >
                Choose from the recommended routes, including train and ferry options.
              </Typography>
            </div>
          </div>

          {/*Track your journey in real-time*/}
          <div className="flex flex-col items-center justify-start gap-3 overflow-hidden lg:my-0">
            <div style={{backgroundImage: `url(${BgOnPt})`}}
                 className="border border-solid border-[#EAEAEE] rounded-[24px] box-border w-full flex justify-center bg-white items-end h-[260px] lg:h-[300px]">
              <img
                src={OurServicesTrack}
                alt="service term search img content"
                className={'h-[245px] lg:h-[280px]'}
                loading={'lazy'}
              />
            </div>

            <div className='w-full flex flex-col items-center justify-center gap-2'>
              <Typography
                variant='h5'
                className='text-[#282B59] text-[24px] font-extrabold leading-hundred tracking-[0px] font-nunito text-center'
              >
                Track your journey in real-time
              </Typography>

              <Typography
                variant='paragraph'
                className='text-[#53557A] text-lg font-nunito font-normal leading-hundred tracking-[0px] text-center'
              >
                See the departure and arrival times, as well as the destination stops, for your chosen train or ferry.
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default OurServices;